import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, delay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  loading$: Observable<boolean> = this.loadingSubject
    .asObservable()
    .pipe(delay(10));

  hide(): void {
    setTimeout(() => this.loadingSubject.next(false));
  }

  show(): void {
    setTimeout(() => this.loadingSubject.next(true));
  }
}
